import { css, Link as MuiLink, linkClasses, styled } from '@mui/material';
import { IcExternalRectangleRegular } from '@kep/kcds-icons';

import type { Theme } from '../../types';
import type { LinkProps } from './types';

const linkColorDefaultStyles = ({
  disabled,
  theme,
}: Pick<LinkProps, 'disabled'> & { theme: Theme }) => css`
  color: ${!disabled ? '#1a62e9' : '#9FBEFF'};
  text-decoration-color: currentColor;

  &:hover {
    color: #1948b2;
  }

  &:active {
    color: #1c347e;
  }

  ${!disabled
    ? theme.mixins.focusRing('outside', {
        selectors: { focus: `&.${linkClasses.focusVisible}` },
        thickness: 1,
        inverse: false,
      })
    : 'outline: none;'};
`;

const linkColorInverseStyles = ({
  disabled,
  theme,
}: Pick<LinkProps, 'disabled'> & { theme: Theme }) => css`
  color: ${!disabled ? '#73A3FF' : '#1A62E9'};
  text-decoration-color: currentColor;
  &:hover {
    color: #9fbeff;
  }

  &:active {
    color: #c6d6ff;
  }

  ${!disabled
    ? theme.mixins.focusRing('outside', {
        selectors: { focus: `&.${linkClasses.focusVisible}` },
        thickness: 1,
        inverse: true,
      })
    : 'outline: none;'};
`;

const LinkRoot = styled(MuiLink, {
  shouldForwardProp: prop => !['color', 'textVariant', 'disabled'].includes(prop as string),
})<LinkProps>(
  ({ textVariant, color, disabled, theme }) => css`
    display: ${textVariant === 'standalone' ? 'block' : 'inline'};
    width: fit-content;
    position: relative;
    pointer-events: ${!disabled ? 'auto' : 'none'};

    ${color === 'default'
      ? linkColorDefaultStyles({ disabled, theme })
      : linkColorInverseStyles({ disabled, theme })}
  `,
);

const LinkExternalIcon = styled(IcExternalRectangleRegular)(
  () => css`
    display: inline;
    margin-left: 2px;
  `,
);

export { LinkRoot, LinkExternalIcon };
